import supabase from 'modules/core/supabase/supabase';
import { BOARD_RESOLUTIONS } from 'modules/manager/domain/board-resolutions';
import { useCallback, useState } from 'react';
import { UDText } from 'ud-ui/components';
import Modal from 'ud-ui/components/modal';
import MediaManagerBoardForm, {
  DEFAULT_RESOLUTION_OPTION,
  MediaManagerBoardFormValues,
} from '../../components/forms/media-manager-board-form';

interface Args {
  templateId: number;
  existingNames: string[];
  boardsCount: number;
  onCreated: () => void;
}

function useCreateBoardModal({ templateId, existingNames, boardsCount, onCreated }: Args) {
  const [isOpen, setIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const open = useCallback(() => setIsOpen(true), []);
  const close = useCallback(() => setIsOpen(false), []);

  const onSubmit = useCallback(
    async (values: MediaManagerBoardFormValues) => {
      setIsLoading(true);
      try {
        const resolution = BOARD_RESOLUTIONS[values.resolution.value];
        await supabase.mediaManager.createBoard({
          name: values.name.trim(),
          objects: [],
          version: '5.3.0',
          templateId,
          order: boardsCount,
          width: resolution.width,
          height: resolution.height,
        });
        onCreated();
        close();
      } catch (error) {
        console.error('Failed to create media manager board:', error);
      } finally {
        setIsLoading(false);
      }
    },
    [templateId, boardsCount, onCreated, close],
  );

  return {
    open,
    close,
    modal: (
      <Modal show={isOpen} onClose={close}>
        <UDText type="title-3" className="mb-5">
          Создать табло
        </UDText>
        <MediaManagerBoardForm
          initialValues={{ name: '', resolution: DEFAULT_RESOLUTION_OPTION }}
          existingNames={existingNames}
          isLoading={isLoading}
          onSubmit={onSubmit}
        />
      </Modal>
    ),
  };
}

export default useCreateBoardModal;
